<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-dialog v-model="dialog.form" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first blue-grey lighten-5 py-5">
          Ubah Data Pembeli / Konsumen
        </v-card-title>
        <v-card-title>
          <ValidationObserver ref="observer" style="width: 100%;">
            <v-form>
              <ValidationProvider name="Nama Pemesan" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama Pemesan"
                  :color="style.primary"
                  prepend-inner-icon="mdi-account-circle-outline"
                  v-model="form.user_name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Handphone" rules="required|min:10|max:13" v-slot="{ errors }">
                <v-text-field
                  type="number"
                  dense
                  outlined
                  label="Handphone"
                  :color="style.primary"
                  prepend-inner-icon="mdi-cellphone-basic"
                  v-model="form.user_mobilephone"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Email"
                  :color="style.primary"
                  prepend-inner-icon="mdi-email-outline"
                  v-model="form.user_email"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="No KTP" rules="required" v-slot="{ errors }">
                <v-text-field
                  type="number"
                  dense
                  outlined
                  label="No KTP"
                  :color="style.primary"
                  prepend-inner-icon="mdi-card-account-details-outline"
                  v-model="form.user_ktp"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <div class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                <div class="v-input__control">
                  <div class="v-input__slot">
                    <div class="v-input__prepend-inner">
                      <div class="v-input__icon v-input__icon--prepend-inner">
                        <i aria-hidden="true" class="v-icon notranslate mdi mdi-map-marker-radius-outline theme--light"></i>
                      </div>
                    </div>
                    <fieldset aria-hidden="true">
                      <legend style="width: 0px;">
                        <span>​</span>
                      </legend>
                    </fieldset>
                    <div class="v-text-field__slot">
                      <label for="input-147" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">
                        <!-- Alamat Konsumen -->
                      </label>
                      <gmap-autocomplete placeholder="Alamat (bisa dikosongi)" :value="form.user_address" :select-first-on-enter="true" @place_changed="setPlace"></gmap-autocomplete>
                    </div>
                  </div>
                  <div class="v-text-field__details">
                    <div class="v-messages theme--light">
                      <div class="v-messages__wrapper">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-form>
          </ValidationObserver>
        </v-card-title>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            :color="style.primary"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            outlined 
            color="red"
            class="text-capitalize red--text"
            :disabled="process.form"
            @click="reset(); $refs.observer.reset();">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.cancel" 
      persistent
      width="450">
      <v-card class="border-radius box-shadow">
        <v-card-text class="body-2 text-first py-5">
          Apakah anda yakin membatalkan booking atas nama <b>{{ detail.user_name }}</b> tipe unit <b>{{ detail.unit_type_name }}</b> blok <b>{{ detail.unit_label }}</b> ?
        </v-card-text>
        <v-card-text>
          <p class="mb-2">
            *Catatan (bisa dikosongi)
          </p>
          <v-textarea
            v-model="form.note"
            auto-grow
            outlined
            rows="1">
          </v-textarea>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            :color="style.primary"
            class="text-capitalize white--text mx-1"
            :loading="process.cancel"
            :disabled="process.cancel"
            @click="canceled">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Ya, Batalkan
          </v-btn>
          <v-btn 
            outlined 
            color="red"
            class="text-capitalize red--text"
            :disabled="process.cancel"
            @click="dialog.cancel = false">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.approve" 
      persistent
      width="450">
      <v-card class="border-radius box-shadow">
        <v-card-title class="d-flex justify-end pb-0">
          <v-icon style="position: absolute; right: 4px;" color="red" class="cursor-pointer" @click="dialog.approve = false">mdi-close-circle-outline</v-icon>
        </v-card-title>
        <v-card-text class="body-2 text-first py-5">
          Apakah anda yakin menyetujui pembatalan booking atas nama <b>{{ detail.user_name }}</b> tipe unit <b>{{ detail.unit_type_name }}</b> blok <b>{{ detail.unit_label }}</b> ?
        </v-card-text>
        <v-card-text>
          <p class="mb-2">
            *Catatan (bisa dikosongi)
          </p>
          <v-textarea
            v-model="form.note"
            auto-grow
            outlined
            rows="1">
          </v-textarea>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            :color="style.primary"
            class="text-capitalize white--text mx-1"
            :loading="process.approve"
            :disabled="process.approve || process.reject"
            @click="approved('approved')">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Ya, Setujui
          </v-btn>
          <v-btn 
            outlined 
            color="red"
            class="text-capitalize red--text"
            :loading="process.reject"
            :disabled="process.reject || process.approve"
            @click="approved('')">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Tolak Pembatalan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.success"
      width="400"
      persistent>
      <v-card 
        color="white"
        class="border-radius pa-2">
        <v-card-text class="pa-0 text-right">
          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.success = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-text>
        <div class="pa-5 pt-0">
          <div class="d-flex align-center mb-5">
            <v-divider color="white"></v-divider>
            <div class="mx-1 font-weight-bold text-second">BERHASIL</div>
            <v-divider color="white"></v-divider>
          </div>
          <div class="d-flex justify-center">
            <div class="sa">
              <div class="sa-success">
                <div class="sa-success-tip"></div>
                <div class="sa-success-long"></div>
                <div class="sa-success-placeholder"></div>
                <div class="sa-success-fix"></div>
              </div>
            </div>
          </div>
          <div class="text-center body-2 text-second line-text-first my-5">
            {{ success.message }}
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" md="3">
        <!-- <v-card
          class="border-radius box-shadow"
          :style="$vuetify.breakpoint.name === 'lg' ? 'position: fixed; min-width: 21%; max-width: 21%;' : ''"> -->
        <v-card
          class="border-radius box-shadow">
          <v-card-title class="font-weight-bold caption text-first py-0 d-flex align-center">
            Info Pembeli / Konsumen
            <v-spacer/>
            <v-tooltip top v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  text
                  class="text-capitalize color-default px-0"
                  v-bind="attrs"
                  v-on="on"
                  @click="reset()">
                  <v-icon small :color="style.primary" class="mr-1">mdi-account-edit</v-icon> 
                  Ubah
                </v-btn>
              </template>
              <span>Ubah Data Konsumen</span>
            </v-tooltip>
          </v-card-title>
          <v-divider class="mx-2"/>
          <v-card-text class="px-0" v-if="Object.keys(detail).length > 0">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-second caption">Nama</td>
                    <td class="text-second text-right caption">
                      {{ detail.user_name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">Handphone</td>
                    <td class="text-second text-right caption">
                      {{ detail.user_mobilephone }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">Email</td>
                    <td class="text-second text-right caption">
                      {{ detail.user_email }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">No KTP</td>
                    <td class="text-second text-right caption">
                      {{ detail.transaction_additional_transaction_data.user_ktp }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">Alamat</td>
                    <td class="text-second text-right caption">
                      {{ detail.transaction_additional_transaction_data.user_address === '' ||  detail.transaction_additional_transaction_data.user_address === null ? '-' : detail.transaction_additional_transaction_data.user_address }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-title class="text-first py-0 caption">
            <span class="font-weight-bold">
              Unit Yang Dibeli
            </span>
            <v-spacer/>
          </v-card-title>
          <v-divider class="mx-2"/>
          <v-card-text class="px-0" v-if="Object.keys(detail).length > 0">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-second caption">Proyek</td>
                    <td class="text-second text-right caption">
                      {{ detail.project_name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">Tipe Unit</td>
                    <td class="text-second text-right caption">
                      Tipe {{ detail.unit_type_name }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">Unit</td>
                    <td class="text-second text-right caption">
                      {{ detail.unit_label }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">Harga</td>
                    <td class="text-second text-right caption">
                      {{ detail.unit_detail.price | price }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-title class="font-weight-bold text-first py-0 caption">
            Progres Pembelian
          </v-card-title>
          <v-divider class="mx-2"/>
          <v-card-text class="px-0" v-if="Object.keys(detail).length > 0">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-second caption">Status</td>
                    <td class="green--text text-right caption">
                      <span v-if="detail.transaction_payment_type === 'KPR'">
                        {{ status().status }}
                      </span>
                      <span v-else>
                        Booking Cash
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">Keterangan</td>
                    <td class="red--text text-right caption">
                      <span v-if="detail.transaction_payment_type === 'KPR'">
                        {{ status().desc }}
                      </span>
                      <span v-else>
                        <!-- Pembayaran Cash -->
                        {{ detail.transaction_payment_type }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-second caption">Tanggal Bayar</td>
                    <td class="text-second text-right caption">
                      {{ status().tempo | date }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-title class="font-weight-bold text-first py-0 caption">
            Print Ulang SPKPR
          </v-card-title>
          <v-divider class="mx-2"/>
          <v-card-text>
            <v-row>
              <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 4:4" md="4" class="py-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      block
                      :color="style.primary"
                      elevation="3"
                      class="text-capitalize white--text"
                      v-bind="attrs"
                      v-on="on"
                      :loading="process.run"
                      :disabled="process.run || process.runs || process.runss"
                      @click="prints">
                      <v-icon small class="mr-1">mdi-file-pdf-outline</v-icon>
                      SPKPR
                    </v-btn>
                  </template>

                  <span>
                    Print SPKPR
                  </span>
                </v-tooltip>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 4:4" md="4" class="py-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      block
                      :color="style.primary"
                      elevation="3"
                      class="text-capitalize white--text"
                      v-bind="attrs"
                      v-on="on"
                      :loading="process.runs"
                      :disabled="process.runs || process.run || process.runss"
                      @click="prints_other">
                      <v-icon small class="mr-1">mdi-file-pdf-outline</v-icon>
                      BLL
                    </v-btn>
                  </template>

                  <span>
                    Print Biaya Lain-lain
                  </span>
                </v-tooltip>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 4:4" md="4" class="py-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      block
                      :color="style.primary"
                      elevation="3"
                      class="text-capitalize white--text"
                      v-bind="attrs"
                      v-on="on"
                      :loading="process.runss"
                      :disabled="process.runss || process.runs || process.run"
                      @click="prints_utj">
                      <v-icon small class="mr-1">mdi-file-pdf-outline</v-icon>
                      UTJ
                    </v-btn>
                  </template>

                  <span>
                    Print Uang Tanda Jadi
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>

          <div v-if="detail.company_project_is_active === '1'">
            <v-card-title class="font-weight-bold text-first pb-0 caption" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')">
              Batalkan Booking ?
            </v-card-title>
            <v-card-title class="font-weight-bold text-first pb-0 caption" v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor')) && detail.transaction_canceled_review_status !== ''">
              Setujui Pembatalan Booking ?
            </v-card-title>

            <v-divider class="mx-2" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator') || (user.user_company_roles_name.includes('supervisor') && detail.transaction_canceled_review_status !== '')"/>

            <v-card-text v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')">
              <v-btn v-if="detail.transaction_canceled_review_status === '' && detail.transaction_canceled_review_datetime === ''"
                small
                block
                color="red"
                elevation="3"
                class="text-capitalize white--text mx-1"
                @click="dialog.cancel = true">
                <v-icon small class="mr-1">mdi-close</v-icon>
                Ajukan Pembatalan
              </v-btn>

              <v-btn v-if="detail.transaction_canceled_review_status === '' && detail.transaction_canceled_review_datetime !== ''"
                small
                block
                color="red"
                elevation="3"
                class="text-capitalize white--text mx-1"
                @click="dialog.cancel = true">
                <v-icon small class="mr-1">mdi-close</v-icon>
                Ajukan Pembatalan Ulang
              </v-btn>

              <div v-if="detail.transaction_canceled_review_status === 'waiting'">
                <p class="color-default font-weight-bold d-flex align-center mb-1">
                  <v-icon small class="mr-1" :color="style.primary">mdi-clock-outline</v-icon>
                  Menunggu Persetujuan Supervisor
                </p>
                <p class="caption text-second ml-5 mb-1">
                  {{ detail.transaction_canceled_review_datetime | date }}
                </p>
                <p class="caption text-second ml-5 mb-1">
                  Keterangan :
                </p>
                <p class="caption text-third ml-5 mb-1">
                  <span v-if="detail.transaction_canceled_review_note !== ''" v-html="detail.transaction_canceled_review_note"></span>
                  <span v-if="detail.transaction_canceled_review_note === ''">-</span>
                </p>
              </div>

              <div v-if="detail.transaction_canceled_review_status === '' && detail.transaction_canceled_review_datetime !== ''">
                <p class="red--text font-weight-bold d-flex align-center mt-3 mb-1">
                  <v-icon small class="mr-1" color="red">mdi-close</v-icon>
                  Ditolak Supervisor
                </p>
                <p class="caption text-second ml-5 mb-1">
                  {{ detail.transaction_canceled_review_status_datetime | date }}
                </p>
                <p class="caption text-second ml-5 mb-1">
                  Keterangan :
                </p>
                <p class="caption text-third ml-5 mb-1">
                  <span v-if="detail.transaction_canceled_review_status_note !== ''" v-html="detail.transaction_canceled_review_status_note"></span>
                  <span v-if="detail.transaction_canceled_review_status_note === ''">-</span>
                </p>
              </div>
            </v-card-text>
            <v-card-text v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor')) && detail.transaction_canceled_review_status !== ''">
              <v-btn v-if="detail.transaction_canceled_review_status === 'waiting'"
                small
                block
                color="teal"
                elevation="3"
                class="text-capitalize white--text mx-1"
                @click="dialog.approve = true">
                <v-icon small class="mr-1">mdi-check</v-icon>
                Setujui Pembatalan
              </v-btn>
              <div v-if="detail.transaction_canceled_review_status === 'waiting'">
                <p class="caption text-second mt-3 mb-1 mx-1">
                  {{ detail.transaction_canceled_review_datetime | date }}
                </p>
                <p class="caption text-second mb-1 mx-1">
                  Keterangan :
                </p>
                <p class="caption text-third mx-1 mb-1">
                  <span v-if="detail.transaction_canceled_review_note !== ''" v-html="detail.transaction_canceled_review_note"></span>
                  <span v-if="detail.transaction_canceled_review_note === ''">-</span>
                </p>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="9">
        <v-card
          min-height="820"
          class="border-radius box-shadow">
          <v-row style="min-height: 515px;">
            <v-col cols="12" class="py-0" v-if="Object.keys(detail).length > 0">
              <Booking class="mb-5" :booking="detail"/>
              <Other class="mb-5" :booking="detail"/>
              <DP class="mb-5" :booking="detail"/>
              <KPR class="mb-5" :booking="detail"/>
              <Development class="mb-5" :booking="detail"/>
              <!-- <Bangun class="mb-5" :booking="detail"/> -->
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  import Booking from '@/components/transaction/Booking.vue';
  import Other from '@/components/transaction/Other.vue';
  import DP from '@/components/transaction/DP.vue';
  import KPR from '@/components/transaction/KPR.vue';
  import Development from '@/components/transaction/Development.vue';
  import Bangun from '@/components/transaction/Bangun.vue';
  export default {
    data () {
      return {
        dialog: {
          form: false,
          success: false,
          cancel: false,
          approve: false
        },
        picker: {
          tempo: false,
          buy: false,
          due: false
        },
        tab: 0,
        menu: [
          {
            label: 'Booking',
            value: '/project/unit/transaction/booking/',
            icon: 'mdi-file-document-edit-outline',
          },
          {
            label: 'Biaya Lain-lain / Titipan',
            value: '/project/unit/transaction/other/',
            icon: 'mdi-cash-plus'
          },
          {
            label: 'Down Payment',
            value: '/project/unit/transaction/dp/',
            icon: 'mdi-cash'
          },
          {
            label: 'Proses KPR',
            value: '/project/unit/transaction/kpr/',
            icon: 'mdi-home-edit-outline'
          },
          {
            label: 'Pembangunan',
            value: '/project/unit/transaction/development/',
            icon: 'mdi-home-import-outline'
          }
        ],
        detail: {},
        form: {
          transaction_id: '',
          place_order_id: '',
          user_id: '',
          user_name: '',
          user_mobilephone: '',
          user_email: '',
          user_ktp: '',
          user_address: '',
          note: ''
        },
        process: {
          run: false,
          runs: false,
          runss: false,
          form: false,
          cancel: false,
          approve: false,
          reject: false
        },
        success: {
          message: ''
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      Booking,
      Other,
      DP,
      KPR,
      Development,
      Bangun,
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'tab': function(val) {
        this.$router.push({ path: `${this.menu[val].value}${this.$route.params.id}?transaction=${this.$route.query.transaction}&unit=${this.$route.query.unit}` })
      }
    },
    mounted () {
      this.tab = this.$route.path === `/project/unit/transaction/booking/${this.$route.params.id}` ? 0 : this.$route.path === `/project/unit/transaction/other/${this.$route.params.id}` ? 1 : this.$route.path === `/project/unit/transaction/dp/${this.$route.params.id}` ? 2 : this.$route.path === `/project/unit/transaction/kpr/${this.$route.params.id}` ? 3 : 4
      this.fetch()
    },
    methods: {
      fetch() {
        get(`auth/company/project/detail-unit-transaction`, {
          params: {
            unit_id: this.$route.query.unit
          }
        })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            if (Object.keys(res.data).length > 0) {
              this.detail = res.data
              this.status()
            } else {
              this.$router.push(`/project`)
            }
          }
        })
      },
      status() {
        let resume = {
          status: '',
          desc: '',
          tempo: ''
        }

        if(Object.keys(this.detail.transaction_status).length > 0) {
          resume = {
            status: this.detail.transaction_status.mortage.title,
            desc: this.detail.transaction_status.mortage.desc,
            // tempo: this.detail.transaction_status.mortage.last_update
            tempo: this.detail.booking_closing_datetime
          }
        } else {
          if (Object.keys(this.detail.transaction_down_payment_status).length > 0) {
            resume = {
              status: this.detail.transaction_down_payment_status.cash_tempo_label,
              desc: !this.detail.transaction_down_payment_status.desc.cash_tempo_closing_datetime ? 'Belum Bayar' : 'Terbayar',
              // tempo: this.detail.transaction_down_payment_status.cash_tempo_due_date
              tempo: this.detail.booking_closing_datetime
            }
          } else {
            resume = {
              status: this.detail.booking_label,
              desc: this.detail.booking_status === 'open' ? 'Belum Bayar' : 'Terbayar',
              // tempo: this.detail.booking_due_date
              tempo: this.detail.booking_closing_datetime
            }
          }
        }

        return resume
      },
      setPlace(place) {
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }

        this.form.user_address = place.formatted_address
      },
      reset() {
        this.dialog.form = !this.dialog.form ? true : false

        this.form = {
          transaction_id: this.detail.transaction_id,
          place_order_id: this.detail.place_order_id,
          user_id: this.detail.user_id,
          user_name: this.detail.user_name,
          user_mobilephone: this.detail.user_mobilephone,
          user_email: this.detail.user_email,
          user_ktp: this.detail.transaction_additional_transaction_data.user_ktp,
          user_address: this.detail.transaction_additional_transaction_data.user_address
        }

        this.process.form = false

        this.error.message = ''
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post(`auth/sales/place-order/update-customer`, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              console.log('berhasil', res)
              this.process.form = false
              this.dialog.form = false
              this.dialog.success = true

              this.success.message = 'Ubah data pembeli / konsumen berhasil!'

              this.fetch()
            } else {
              console.log('gagal', res)
              this.process.form = false
              this.error.message = res.msg
            }
          })
        }
      },
      async prints() {
        this.process.run = true
        await get(`auth/company/surat-pesanan-pembelian/print`, {
          params: {
            transaction_id: this.detail.transaction_id
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false

            window.open(res.data.url, '_blank')
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      },
      async prints_other() {
        this.process.runs = true
        await get(`auth/company/surat-biaya-lain/print`, {
          params: {
            transaction_id: this.detail.transaction_id
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.runs = false

            window.open(res.data.url, '_blank')
          } else {
            this.process.runs = false
            this.error.message = res.msg
          }
        })
      },
      async prints_utj() {
        this.process.runss = true
        await get(`auth/transaction/utj/print`, {
          params: {
            transaction_id: this.detail.transaction_id
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.runss = false

            window.open(res.data.url, '_blank')
          } else {
            this.process.runss = false
            this.error.message = res.msg
          }
        })
      },
      async canceled() {
        this.process.cancel = true
        await post(`auth/transaction/cancel`, {
          data: {
            trans_id: this.detail.transaction_id,
            notes: this.form.note,
            status: 'waiting'
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.cancel = false
            this.dialog.cancel = false

            this.fetch()
          } else {
            this.process.cancel = false
            this.error.message = res.msg
          }
        })
      },
      async approved(type) {
        this.process.approve = type === 'approved' ? true : false
        this.process.reject = type === '' ? true : false

        await post(`auth/transaction/cancel`, {
          data: {
            trans_id: this.detail.transaction_id,
            notes: this.form.note,
            status: type
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.approve = false
            this.dialog.approve = false

            if (type === 'approved') {
              this.$router.push(`/project`)
              window.open(res.data.url, '_blank')
            } else {
              this.fetch()
            }
          } else {
            this.process.cancel = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>

<style>
.actived {
  background: var(--color-primary);
}
.border-item {
  border-radius: 10px 0px 0px 0px !important;
}
.caret {
  position: absolute;
  right: 0;
  top: 18px;
  bottom: 18px;
}
.caret:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border-left: 10px solid #4FC3F7;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.v-label {
  font-size: 10px !important;
}
</style>

<style lang="scss">
.sa {
  width: 140px;
  height: 140px;
  padding: 26px;
  background-color: #fff;
  &-success {
    border-radius: 50%;
    border: 4px solid #4FC3F7;
    box-sizing: content-box;
    height: 80px;
    padding: 0;
    position: relative;
    background-color: #fff;
    width: 80px;
    &:after, &:before {
      background: #fff;
      content: '';
      height: 120px;
      position: absolute;
      transform: rotate(45deg);
      width: 60px;
    }
    &:before {
      border-radius: 40px 0 0 40px;
      width: 26px;
      height: 80px;
      top: -17px;
      left: 5px;
      transform-origin: 60px 60px;
      transform: rotate(-45deg);
    }
    &:after {
      border-radius: 0 120px 120px 0;
      left: 30px;
      top: -11px;
      transform-origin: 0 60px;
      transform: rotate(-45deg);
      animation: rotatePlaceholder 4.25s ease-in;
    }
    &-placeholder {
      border-radius: 50%;
      border: 4px solid rgb(230 246 254 / 75%);
      box-sizing: content-box;
      height: 80px;
      left: -4px;
      position: absolute;
      top: -4px;
      width: 80px;
      z-index: 2;
    }
    &-fix {
      background-color: #fff;
      height: 90px;
      left: 28px;
      position: absolute;
      top: 8px;
      transform: rotate(-45deg);
      width: 5px;
      z-index: 1;
    }
    &-tip, &-long {
      background-color: #4FC3F7;
      border-radius: 2px;
      height: 5px;
      position: absolute;
      z-index: 2;
    }
    &-tip {
      left: 14px;
      top: 46px;
      transform: rotate(45deg);
      width: 25px;
      animation: animateSuccessTip .75s;
    }
    &-long {
      right: 8px;
      top: 38px;
      transform: rotate(-45deg);
      width: 47px;
      animation: animateSuccessLong .75s;
    }
  }
}
@keyframes animateSuccessTip {
  0%, 54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessLong {
  0%, 65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@keyframes rotatePlaceholder {
  0%, 5% {
    transform: rotate(-45deg);
  }
  100%, 12% {
    transform: rotate(-405deg);
  }
}
</style>